import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IAuthStatusEnum } from '@features/auth/interfaces/auth.interface';
import { AuthService } from '@features/auth/services/auth.service';
import { map } from 'rxjs';

export const notAuthenticatedGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  const _authService = inject(AuthService);

  if (_authService.authStatus() === IAuthStatusEnum.authenticated) return true;

  return _authService.checkAuthStatus().pipe(
    map((response: boolean) => {

      if (response) return true;

      return _router.createUrlTree(['/auth']);
    })
  );
};
